import React from 'react';

// STYLES
import styles from '@UILayer/UILayer.scss';
import { ReadyStateCheckIcon } from './ReadyStateCheck.icon';

export const MissingFieldsMessage: React.FC<{ fields: Array<string> }> = ({ fields }) => {
    return (
        <>
            {fields.length > 0 && (
                <div className={styles.rsc_message_container}>
                    <div className={styles.rsc_message_icon}>
                        <ReadyStateCheckIcon />
                    </div>
                    <div className={styles.rsc_message_header}>
                        Missing URL
                        <br /> authentication parameters:
                    </div>
                    <div className={styles.rsc_message_list}>
                        {fields.map((key, index) => (
                            <span key={index}> {key}</span>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};
